(() => {
  const MONTHS_AR = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
  ];

  function getEgyptTodayUtc() {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Africa/Cairo',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date());

    const values = {};
    parts.forEach((part) => {
      if (part.type !== 'literal') values[part.type] = Number(part.value);
    });

    return new Date(Date.UTC(values.year, values.month - 1, values.day));
  }

  function isBusinessDay(date) {
    const day = date.getUTCDay();
    return day !== 5 && day !== 6;
  }

  function addBusinessDays(startDate, businessDays) {
    const date = new Date(startDate.getTime());
    let counted = 0;

    while (counted < businessDays) {
      date.setUTCDate(date.getUTCDate() + 1);
      if (isBusinessDay(date)) counted += 1;
    }

    return date;
  }

  function formatArabicDate(date) {
    return `${date.getUTCDate()} ${MONTHS_AR[date.getUTCMonth()]}`;
  }

  function renderDeliveryEstimate(element) {
    const minDays = Number(element.dataset.minBusinessDays || 7);
    const maxDays = Number(element.dataset.maxBusinessDays || 15);
    const output = element.querySelector('[data-pan-delivery-range]');

    if (!output || !Number.isFinite(minDays) || !Number.isFinite(maxDays)) return;

    const today = getEgyptTodayUtc();
    const earliest = addBusinessDays(today, minDays);
    const latest = addBusinessDays(today, maxDays);

    output.textContent = `خلال الفترة من ${formatArabicDate(earliest)} إلى ${formatArabicDate(latest)}`;
  }

  function initDeliveryEstimates(root = document) {
    root.querySelectorAll('[data-pan-delivery-estimate]').forEach(renderDeliveryEstimate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initDeliveryEstimates());
  } else {
    initDeliveryEstimates();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initDeliveryEstimates(event.target);
  });
})();
